// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

export const API_URL =
  import.meta.env.VITE_BACKEND_URL

// DEV-496 — email/password sign-up is temporarily gated off; new accounts
// come only through GitHub. The Backend enforces the block (403 on
// /auth/signup); this flag hides the email sign-up entry in the UI so the
// two stay in sync. Enabled unless explicitly set to "false" (missing key
// never silently disables sign-up). Re-enabled behind a verified funnel in
// DEV-495.
export const EMAIL_SIGNUP_ENABLED =
  import.meta.env.VITE_EMAIL_SIGNUP_ENABLED !== "false"

// M7 — Sentry (browser errors / RUM). When the DSN is absent the SPA
// runs with observability disabled (dev/local). The browser ships to
// Sentry only — never to the cloud log store (ADR-0041 / ADR-0039).
export const SENTRY_DSN: string | undefined = import.meta.env.VITE_SENTRY_DSN
export const SENTRY_ENVIRONMENT: string | undefined =
  import.meta.env.VITE_SENTRY_ENVIRONMENT
export const SENTRY_RELEASE: string | undefined =
  import.meta.env.VITE_SENTRY_RELEASE